import React from "react";
import WithSnowFlakes from "../../components/LandingPage/WithSnowFlakes";
import ContactUsForm from "../../components/Form/ContactUsForm";

const ContactUsPage = () => {
  return (
    <WithSnowFlakes>
      <div className="flex flex-col w-full items-center px-4 py-20 overflow-scroll ">
        <div className="w-full max-w-[1200px]">
          <div className="text-snow-white font-bold text-5xl font-catamaran text-center">
            Contact Us
          </div>
          <ContactUsForm />
        </div>
      </div>
    </WithSnowFlakes>
  );
};

export default ContactUsPage;

let phoneNumber = 2482909029;
let phoneNumberFormatted = "(248) 290-9029";
export { phoneNumber, phoneNumberFormatted };
